import React from 'react';
import { connect } from 'react-redux';

import DialogFactory from '../../../factory/DialogFactory';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';

export class DeleteDialogClass extends React.Component {
    cancel = () => {
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.toggleDeleteBlockDialog(
            block,
            exercise,
            false,
            'Exercise'
        );
    };

    delete = () => {
        const type = this.getType();
        switch (type) {
            case 'Block':
                return this.deleteBlock();
            case 'Exercise':
                return this.deleteExercise();
            case 'Session':
                return this.deleteSession();
            default:
                return;
        }
    };

    deleteBlock = () => {
        DesignerState.deleteBlock(this.props.session, this.props.block);
    };

    deleteExercise = () => {
        DesignerState.deleteExercise(this.props.block, this.props.exercise);
    };

    deleteSession = () => {
        DesignerState.deleteSession(this.props.day, this.props.session.data);
    };

    getType = () => {
        return this.props.deleteBlockBind && this.props.deleteBlockBind.type
            ? this.props.deleteBlockBind.type
            : '';
    };

    getTitle = () => {
        return this.props.deleteBlockBind && this.props.deleteBlockBind.title
            ? this.props.deleteBlockBind.title
            : '';
    };

    headerText = () => {
        const title = this.getTitle();
        return `Delete ${title}?`;
    };

    messageText = () => {
        const type = this.getType();
        return `Are you sure you want to delete this ${type.toLowerCase()}?`;
    };

    render() {
        Console.render('DeleteBlockDialog');
        return (
            <DialogFactory
                enabled={this.props.deleteBlockDialog}
                handleClose={this.cancel}
                handleSave={this.delete}
                header={this.headerText()}
                text={<span>{this.messageText()}</span>}
                saveButtonTitle="Delete"
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        block: state.calendar.uiTree.block,
        day: state.calendar.uiTree.day,
        deleteBlockDialog: !!state.calendar.uiTree.deleteBlockDialog,
        deleteBlockBind: state.calendar.uiTree.deleteBlockBind,
        exercise: state.calendar.uiTree.exercise,
        session: state.calendar.uiTree.session,
        ...ownProps
    };
};

export default connect(mapStateToProps)(DeleteDialogClass);



// WEBPACK FOOTER //
// ./src/view/designer/components/dialogs/DeleteDialog.jsx